import API from '../dataApi';

export const getPdfConfigs      = ()                              => API.get('/pdf-config');
export const upsertPdfConfig    = (reportType, payload)           => API.put(`/pdf-config/${reportType}`, payload);
export const clearPdfConfig     = (reportType)                    => API.delete(`/pdf-config/${reportType}`);
export const clearAllPdfConfigs = ()                              => API.delete('/pdf-config');
